import getTextValue from 'src/core/CoreSelectionList/functions/getTextValue'
import type { CoreSelectionListItem } from 'src/core/CoreSelectionList/types'

/** Для `multiple`: добавить пункт в выбор или убрать (сравнение по тексту поля). */
export default function toggleSelectedItem(
  selectedItems: CoreSelectionListItem[],
  clickedItem: CoreSelectionListItem,
  itemText: string,
): CoreSelectionListItem[] {
  const clickedText = getTextValue(clickedItem, itemText)
  const alreadySelected = selectedItems.some(
    selectedItem => getTextValue(selectedItem, itemText) === clickedText,
  )

  if (alreadySelected) {
    return selectedItems.filter(
      selectedItem => getTextValue(selectedItem, itemText) !== clickedText,
    )
  }

  return [...selectedItems, clickedItem]
}
